/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesUk = {
  privacy: {
    pageTitle: "Політика конфіденційності",
    lastUpdated: "Останнє оновлення: 1 червня 2026",
    introduction: {
      title: "Вступ",
      body: "WasOK — це локально орієнтований помічник для покупок, створений, щоб допомагати користувачам пам’ятати продукти, які вони раніше купували, оцінювали або рецензували.\n\nЦя Політика конфіденційності пояснює, яка інформація обробляється під час використання програми, як зберігаються дані та як можуть працювати певні сторонні сервіси.",
    },
    dataStored: {
      title: "Дані, які зберігає програма",
      body: "WasOK зберігає таку інформацію локально на вашому пристрої:\n\n• відскановані штрихкоди продуктів\n• назви продуктів і деталі, введені користувачем\n• оцінки та коментарі\n• списки покупок\n• категорії продуктів\n• ціни та інформацію про магазини\n• фотографії продуктів і магазинів\n\nВаші дані про продукти та фотографії не завантажуються на сервери WasOK.",
    },
    permissions: {
      title: "Використовувані дозволи",
      camera: {
        title: "Камера",
        body: "Доступ до камери використовується для:\n\n• сканування штрихкодів\n• зйомки фотографій продуктів",
      },
      photos: {
        title: "Фотографії та медіа",
        body: "Доступ до фотографій або галереї використовується лише коли:\n\n• ви додаєте зображення до продуктів\n• відновлюєте резервні копії з фотографіями",
      },
      files: {
        title: "Доступ до файлів і сховища",
        body: "Доступ до файлів може використовуватися для:\n\n• експорту файлів резервних копій\n• імпорту резервних копій, вибраних користувачем\n• спільного використання списків покупок або резервних копій",
      },
    },
    backup: {
      title: "Функції резервного копіювання та експорту",
      body: "WasOK дозволяє користувачам створювати файли резервних копій із даними програми та необов’язковими фотографіями.\n\nФайли резервних копій створюються локально на вашому пристрої та можуть зберігатися або передаватися за допомогою сервісів, вибраних користувачем, наприклад:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• локальне сховище пристрою\n\nWasOK не завантажує резервні копії на власні сервери.",
      onlineProductLookup: {
        title: "Онлайн-пошук продуктів",
        body: "Коли ви вмикаєте онлайн-пошук за штрихкодом у Налаштуваннях, WasOK може надіслати лише відсканований номер штрихкоду до публічних баз продуктів (наприклад, Open Food Facts), щоб запропонувати назву продукту та бренд. WasOK не завантажує для цієї функції ваші оцінки, коментарі, фотографії, списки покупок, категорії, інформацію про магазини чи дані резервних копій. Ви можете вимкнути це в будь-який час у Налаштуваннях.",
      },
    },
    advertising: {
      title: "Реклама та сторонні сервіси",
      intro:
        "WasOK використовує вибрані сторонні сервіси для надання певних функцій.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob використовується для показу реклами в програмі.\n\nGoogle і його партнери можуть обробляти інформацію, таку як:\n\n• рекламні ідентифікатори\n• інформація про пристрій\n• IP-адреса\n• діагностична та статистична інформація\n\nКористувачів у певних регіонах можуть попросити про згоду перед показом персоналізованої реклами.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK використовує Firebase Crashlytics, щоб виявляти збої та покращувати стабільність програми.\n\nЗвіти про збої можуть містити технічну інформацію, таку як:\n\n• модель пристрою\n• версія операційної системи\n• версія програми\n• діагностика збоїв\n\nЗвіти про збої навмисно не містять ваших оцінок продуктів, нотаток, списків покупок чи фотографій.",
      },
      externalProductDatabases: {
        title: "Зовнішні бази продуктів",
        body: "Функція пошуку за штрихкодом може використовувати зовнішні бази продуктів для отримання інформації про продукти.\n\nДля отримання додаткової інформації ознайомтеся з політиками конфіденційності відповідних постачальників.",
      },
    },
    dataSecurity: {
      title: "Безпека даних",
      body: "WasOK зберігає дані програми локально на вашому пристрої за допомогою механізмів зберігання операційної системи.\n\nХоча вживаються розумні заходи для захисту локальних даних програми, жоден метод електронного зберігання не є повністю безпечним.\n\nКористувачі відповідають за створення резервних копій важливих даних, якщо бажають.",
    },
    children: {
      title: "Конфіденційність дітей",
      body: "WasOK не призначений для дітей віком до 13 років.",
    },
    notifications: {
      title: "Сповіщення",
      body: "WasOK може за бажанням створювати локальні сповіщення на вашому пристрої, щоб нагадувати оцінити продукти після покупки.\n\nЦі сповіщення генеруються та плануються локально на вашому пристрої й не потребують облікового запису чи віддаленого сервера.\n\nВи можете вимкнути сповіщення в будь-який час у налаштуваннях пристрою або в програмі, якщо це підтримується.",
    },
    yourControl: {
      title: "Ваш контроль над даними",
      body: "Ви можете:\n\n• будь-коли редагувати або видаляти збережені продукти\n• очищати дані програми на пристрої\n• видаляти програму\n• експортувати резервні копії своїх даних",
    },
    changes: {
      title: "Зміни до цієї політики",
      body: "Цю Політику конфіденційності можна час від часу оновлювати.\n\nЗміни набувають чинності після публікації оновленої версії.",
    },
    contact: {
      title: "Контакт",
      body: "Якщо у вас є запитання щодо цієї Політики конфіденційності, звертайтеся:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Умови використання",
    lastUpdated: "Останнє оновлення: 1 червня 2026",
    acceptance: {
      title: "Прийняття умов",
      body: "Завантажуючи, встановлюючи або використовуючи WasOK, ви погоджуєтеся з цими Умовами використання.\n\nЯкщо ви не згодні з цими Умовами, вам не слід користуватися програмою.",
    },
    license: {
      title: "Ліцензія",
      body: "WasOK надає вам обмежену, невиключну, непередавану, відкличну ліцензію на використання програми відповідно до цих Умов.",
    },
    acceptableUse: {
      title: "Прийнятне використання",
      body: "Ви погоджуєтеся не:\n\n• зловживати програмою\n• втручатися в роботу програми\n• намагатися здійснити зворотну розробку або змінювати програму\n• використовувати програму з порушенням застосовних законів чи нормативних актів",
    },
    localData: {
      title: "Локальні дані та резервні копії",
      body: "WasOK зберігає дані користувача локально на пристрої.\n\nКористувачі відповідають за створення резервних копій важливих даних, якщо бажають.\n\nХоча функціональність резервного копіювання та відновлення може бути доступна, WasOK не гарантує захист від втрати, пошкодження чи збою збережених даних.",
    },
    advertisements: {
      title: "Реклама",
      body: "Програма може показувати рекламу, надану сторонніми рекламними партнерами, включно з Google AdMob.",
    },
    noWarranty: {
      title: "Відсутність гарантій",
      body: "WasOK надається «як є» та «як доступно» без гарантій будь-якого виду, явних чи неявних.\n\nМи не гарантуємо, що:\n\n• програма завжди буде доступна\n• програма буде безпомилковою\n• ніколи не станеться втрата даних\n• усі функції працюватимуть безперебійно на всіх пристроях",
    },
    limitationLiability: {
      title: "Обмеження відповідальності",
      body: "У максимальній мірі, дозволеній законом, WasOK і його розробники не несуть відповідальності за:\n\n• втрату даних\n• втрату прибутку\n• проблеми з пристроєм\n• непрямі чи наслідкові збитки\n• перерви внаслідок використання або неможливості використовувати програму",
    },
    thirdParty: {
      title: "Сторонні сервіси",
      body: "Певні функції або вміст можуть залежати від сторонніх сервісів, включно з постачальниками реклами та зовнішніми сервісами зберігання/спільного доступу, вибраними користувачем.\n\nWasOK не відповідає за сторонні сервіси чи їхні політики.",
    },
    productInformation: {
      title: "Інформація про продукти",
      body: "Певні деталі продуктів можуть бути отримані від сторонніх сервісів пошуку за штрихкодом.\n\nWasOK не гарантує точність, повноту, доступність чи придатність інформації, наданої зовнішніми джерелами даних.\n\nКористувачі повинні самостійно перевіряти інформацію про продукти, коли це необхідно.",
    },
    changesApp: {
      title: "Зміни програми",
      body: "WasOK може бути змінено, оновлено, призупинено або припинено в будь-який час без попереднього повідомлення.",
    },
    changesTerms: {
      title: "Зміни до цих Умов",
      body: "Ці Умови можуть періодично оновлюватися.\n\nПродовження використання програми після набрання чинності оновленнями означає прийняття переглянутих Умов.",
    },
    contact: {
      title: "Контакт",
      body: "Із запитаннями щодо цих Умов звертайтеся:\n\nsupport@wasok.app",
    },
  },
};
